module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_a02/main_pc_e0f162277baa2080b90333b8ad7fd496.jpg";